import React, { Component } from 'react';
import { Panel } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import {registrarWelcome} from '../../../actions'/*Inicio Req 93426 ebarboza 29 11 2021 */
import createFichaVenta from '../../../utils/createFichaVenta';
import assignProforma from '../../../utils/assignProforma';
import assignConditions from '../../../utils/assignConditions';
import assignColors from '../../../utils/assignColors';
import formatMoney from '../../../utils/formatMoney';
import Autocomplete from 'react-autocomplete';
import { FadeLoader } from 'react-spinners';
import { result } from 'lodash-es';

const menuStyle = {
  position: 'absolute',
  left: '0',
  top: '100%',
  maxHeight: '350px',
  overflow: 'auto',
  border: '1px solid #cccccc',
};


const inputProps = {
  className: 'form-control awesomplete pillSelct-input',
  name: 'colaborador',
};


const CondicionCheckbox = props => (

  <div className='checkbox'>
    <label htmlFor={`${props.checkAttach.id}`}>
      <input
          type='checkbox'
          id={props.checkAttach.id}
          name={props.checkAttach.descripcion}
          onChange={e => props.onCheckAttach(e, props.nroProforma)}
          checked={props.selectAttachCheck.indexOf(props.checkAttach.id)>=0}
      />
      <div className='checkbox-skin' />
      {props.checkAttach.descripcion}
    </label>

  </div>
);
const Checks = (props) => {
  if (props.condiciones.length || (props.capacitaciones.indexOf(props.nroProforma)>=0)) {
    return (
      <div>
        <hr />
        <ul className='list list-check'>
          {
            props.condiciones.map(condicion => (
              <li key={condicion}>{condicion.split('---')[1]}</li>
            ))
          }
{/*          {
            props.capacitaciones.includes(props.nroProforma)
          }*/}
        </ul>
      </div>
    );
  }
  return null;
};

const Observaciones = (props) => {
  if (props.observaciones) {
    return (
      <div>
        <p className='labelInfo'>Observación</p>
        <p>{props.observaciones}</p>
      </div>
    );
  }
  return null;
};

const Color = (props) => {
  if (props.colores.filter(String).length) {
    return (
      <div className='col-md-4'>
        <p className='labelInfo'>Color</p>
        <p>{props.colores.filter(String).map(color => color.split('---')[1]).join(', ')}</p>
      </div>
    );
  }
  return null;
};

/*Inicio Req 93426 ebarboza 29 11 2021 */
const WilcomePack = (props) => {
  if (props.WilcomePack.filter(String).length) {
    return (
      <div className='col-md-12'>
        <p className='labelInfo'>Welcome Pack</p>
        <p>{props.WilcomePack.filter(String).map(welcomePack => welcomePack.split('---')[1]).join(', ')}</p>
      </div>
    );
  }
  return null;
};
/*Fin Req 93426 ebarboza 29 11 2021 */

const Uso = (props) => {
  if (props.usos) {
    return (
      <div className='col-md-4'>
        <p className='labelInfo'>Uso</p>
        <p>{props.usos.split('---')[1]}</p>
      </div>
    );
  }
  return null;
};

const ColorUso = (props) => {
  console.log(props.colores);
  console.log(props.colores.filter(String));
  if (props.usos || props.colores.filter(String).length) {
    return (
      <div>
        <hr />
        <div className='row'>
          <Color colores={props.colores} />
          <Uso usos={props.usos} />
          <WilcomePack WilcomePack={props.WilcomePack} />{/*Inicio Req 93426 ebarboza 29 11 2021 */}
        </div>
      </div>
    );
  }
  return null;
};

const ADJUNTA_FV = '0001';
const ADJUNTA_PROFORMA = '0002';
const SPLIT = '---';

class ThirdStep extends Component {
  

  constructor(props) {
    super(props);

    this.state = {
      cardExpanded: [],
      isCreating: false,
      selectAttachCheck: [],
      muestraLoad:'none',
      //< I Req 90859 soporte legados 14 09 2021>
      alerta2:'none',
      mensaje2: '',
      classmensaje: 'btn btn-success',
      //< F Req 90859 >
    };
  }

  onCheckAttach = (e) => {
    const attachCheck = e.target.id;
    const { selectAttachCheck } = this.state;
    if (selectAttachCheck.indexOf(attachCheck)>=0) {
      this.setState({ selectAttachCheck: selectAttachCheck
                                            .filter(cond => cond !== attachCheck) });
    } else {
      this.setState({ selectAttachCheck: [...selectAttachCheck, attachCheck] });
    }
  }

  toggleCard = (proforma) => {
    const { cardExpanded } = this.state;
    if (cardExpanded.indexOf(proforma)>=0) {
      this.setState({ cardExpanded: cardExpanded.filter(it => it !== proforma) });
    } else {
      this.setState({ cardExpanded: [...cardExpanded, proforma] });
    }
  }

  asignarProformas = (fdvID) => {
    const {
      usosProforma,
      condicionesProforma, capacitacionesProforma,
      codAreaVta,colaboradoresSeleccionados, coloresProformaList, obsFichaVtaVeh,welcomePackEquipo
    } = this.props;

    const promises = [];
    let proformaList = [];


    this.props.proformas.forEach(({ nroProforma },index) => {

      const uso = usosProforma[nroProforma].split(SPLIT)[0];
      const capacitacion = typeof(condicionesProforma[nroProforma].find(capacitacion => parseInt(capacitacion.split(SPLIT)[0]) === 1)) !== 'undefined' ? 1 : 0;
      const colores = coloresProformaList[index][nroProforma].map(color => color.split(SPLIT)[0]);
      const condiciones = condicionesProforma[nroProforma].map(condicion => parseInt(condicion.split(SPLIT)[0], 10));
      const destinatarios = colaboradoresSeleccionados===undefined?[]:colaboradoresSeleccionados.map(entry => { return entry.id});
      const adjuntarFichaVenta = this.state.selectAttachCheck.indexOf(ADJUNTA_FV)>=0;
      const adjuntarProforma = this.state.selectAttachCheck.indexOf(ADJUNTA_PROFORMA)>=0;

      proformaList.push({
        numProfVeh:nroProforma,
        codAVtaFamUso:uso,
        indSoliCapacitacion:capacitacion,
        destinatarios:destinatarios,
        adjuntarFichaVenta:adjuntarFichaVenta,
        adjuntarProforma:adjuntarProforma,
        codigoDeAreaVta:codAreaVta,
        codigosDeCheck:condiciones,
        codigosDeColor:colores,
        obsFacturacion:obsFichaVtaVeh
      });
      promises.push(registrarWelcome(welcomePackEquipo,nroProforma,fdvID))/*Inicio Req 93426 ebarboza 29 11 2021 */
    
    });
    promises.push(assignProforma(fdvID,proformaList));

    return Promise.all(promises).then(() => (
      this.props.history.push({
        pathname: `/fichas-venta/${fdvID}`,
        state: { message: '¡Se ha creado la nueva ficha de venta con éxito!' },
      })
    ));
  }

//< I Req 90859 soporte legados 14 09 2021>
  openAlert = (data) => {
    if (data.estadoTrama === '0') {
      this.setState({ alertErrorMessage: data.mensaje });
      this.showAlert('alertErrorOpen');
    } else if (data.estadoTrama === '1') {
      this.setState({ alertSuccessMessage: data.mensaje });
      this.showAlert('alertSuccessOpen');
    } else {
      this.setState({ alertErrorMessage: `Hubo un error con el servicio ${data.estadoTrama}` });
      this.showAlert('alertErrorOpen');
    }
  }

  showAlert = (alertType) => {
    this.setState({ [alertType]: true });
    setTimeout(() => this.setState({ [alertType]: false }), 5000);
  }
  //< F Req 90859 >
  
  submit = () => {
    this.setState({ isCreating: true });//Req 90859 SoporteLegados 22 11 2021

    const {
      codAreaVta, codCia, codCliente,
      codFilial, codVendedor, obsFichaVtaVeh, fdvID
    } = this.props;
    /*Inicio Req 92293 ebarboza 26 07 2021*/
    let codMoneda =  this.props.proformas[0].codMoneda
    let codTipoPago = this.props.proformas[0].codTipoPago
    /*Fin Req 92293 ebarboza 26 07 2021*/
    console.log("Proforma:>>  ",this.props.proformas[0])
                  if (this.props.nuevaFDV) {
                    createFichaVenta(
                      {
                        codAreaVta,
                        codCia,
                        codCliente,
                        codFilial,
                        codVendedor,
                        obsFichaVtaVeh,
                        codTipoPago,//Req 92293 ebarboza 26 07 2021
                        codMoneda//Req 92293 ebarboza 26 07 2021
                      })
                    .then(({ data }) => {
                      if (data.codigo) {
                        this.asignarProformas(data.codigo).then(result => {
                          //< I Req 90859 soporte legados 14 09 2021>
                          this.setState({ isCreating: true });
                          this.setState({ alerta2: 'block' });
                          this.setState({ mensaje2: data.mensaje });
                          this.setState({ classmensaje: 'alert alert-success over-modal'});
                          //< F Req 90859 >

                          window.location.reload();
                        });
                      } else {
                        //< I Req 90859 soporte legados 14 09 2021>
                        this.setState({ alerta2: 'block' });
                        this.setState({ mensaje2: data.mensaje });
                        this.setState({ classmensaje: 'alert alert-danger over-modal'});

                        this.setState({ muestraLoad: 'none' });
                        this.setState({ isCreating: false });
                        //< F Req 90859 >
                      }
                    });
                  } else {
                    this.asignarProformas(fdvID)
                      .then(() => {
                        window.location.reload();
                      })
                      .catch((error) => {
                        console.log(error);

                        //< I Req 90859 soporte legados 14 09 2021>
                        this.setState({ alerta2: 'block' });
                        this.setState({ mensaje2: error });
                        this.setState({ classmensaje: 'alert alert-danger over-modal'});
                        this.setState({ muestraLoad: 'none' });
                        //< F Req 90859 >

                        this.setState({ isCreating: false });
                      });
                  }

  }

  //< I Req 90859 soporte legados 14 09 2021 Se agrego linea de codigo 460 a 463 la cual muestra la alerta >
  render() {
  
    const { cardExpanded, isCreating } = this.state;
    const {
      condicionesProforma, capacitacionesProforma,
      usosProforma, coloresProforma , coloresProformaList
    } = this.props;

    return (
      
      <div>
        {
          this.props.proformas.map((proforma,index) => {
            
            const moneda = proforma.moneda === 'Dólares' ? 'US$' : 'S/';
            const arrowButton = (cardExpanded.indexOf(proforma.nroProforma) >=0 )? 'card-lg-title btn-clean' : 'card-lg-title btn-clean collapsed';
            return (
              <div className='card card-plain card-lg form-group' key={proforma.nroProforma}>
                <div className='row'>
                  <div className='col-xs-8'>
                    <button
                      className={arrowButton}
                      onClick={() => this.toggleCard(proforma.nroProforma)}
                    >
                      <h3>Proforma {proforma.nroProforma}<i className='ion-chevron-up ml-3 c-cyan' /></h3>
                    </button>
                  </div>
                </div>
                <Panel
                  className='custom-panel card-panel'
                  collapsible
                  expanded={! (cardExpanded.indexOf(proforma.nroProforma)>=0)}
                >
                  <div className='collapse in'>
                    <div className='row mt-3'>
                      <div className='col-md-5ths'>
                        <p className='labelInfo'>Familia</p>
                        <p>{proforma.familia}</p>
                      </div>
                      <div className='col-md-5ths'>
                        <p className='labelInfo'>Marca</p>
                        <p>{proforma.marca}</p>
                      </div>
                      <div className='col-md-5ths'>
                        <p className='labelInfo'>Modelo</p>
                        <p>{proforma.desBaumuster}</p>
                      </div>
                      <div className='col-md-5ths'>
                        <p className='labelInfo'>Cant. Unid.</p>
                        <p>{proforma.cantidad}</p>
                      </div>
                      <div className='col-md-5ths'>
                        <p className='labelInfo'>Carrocero</p>
                        <p>{proforma.proveedorCarrocero}</p>
                      </div>
                    </div>
                    <div className='row mt-3'>
                      <div className='col-md-5ths'>
                        <p className='labelInfo'>Valor venta x unidad</p>
                        <p>{moneda} {formatMoney(proforma.valTotalProforma)}</p>
                      </div>
                      <div className='col-md-5ths'>
                        <p className='labelInfo'>Descuento</p>
                        <p>{moneda} {formatMoney(proforma.montoDesc)}</p>
                      </div>
                      <div className='col-md-5ths'>
                        <p className='labelInfo'>Valor venta dscto.</p>
                        <p>{moneda} {formatMoney(proforma.montoDesc)}</p>
                      </div>
                      <div className='col-md-5ths'>
                        <p className='labelInfo'>Precio venta x unid.</p>
                        <p>{moneda} {formatMoney(proforma.precioUnitario)}</p>
                      </div>
                      <div className='col-md-5ths'>
                        <p className='labelInfo'>Total venta</p>
                        <p>{moneda} {formatMoney(proforma.precioTotal)}</p>
                      </div>
                    </div>
                  </div>
                  <Checks
                    condiciones={condicionesProforma[proforma.nroProforma]}
                    capacitaciones={capacitacionesProforma}
                    nroProforma={proforma.nroProforma}
                  />
                  {console.log('logger',coloresProforma)}
                  <ColorUso
                    usos={usosProforma[proforma.nroProforma]}
                    colores={coloresProformaList[index]!==undefined?coloresProformaList[index][proforma.nroProforma]:coloresProformaList[proforma.nroProforma]}
                    WilcomePack={this.props.selectEquipoWelcomePack}/*Inicio Req 93426 ebarboza 29 11 2021 */
                  />
                </Panel>
              </div>
            );
          })
        }
        {this.props.tipoComponente!==1?(

        <div className='row' >
            <div className='col-md-6'>
                <p className='labelInfo'>Notificar</p>
                <div className='pillSelct-field' >
                  <div className='awesomplete'>
                    <Autocomplete
                      getItemValue={item => item.idUsuario.toString()}
                      value={this.props.colaborador}
                      items={this.props.colaboradores}
                      renderItem={(item, isHighlighted) =>
                        <div key={item.idUsuario} style={{ background: isHighlighted ? 'lightgray' : 'white', padding: '6px 12px' }}>
                          {`${item.apellidos} ${item.nombre}`}
                        </div>
                      }
                      onChange={this.props.changeColaborador}
                      menuStyle={menuStyle}
                      inputProps={inputProps}
                      wrapperStyle={{ display: 'block' }}
                      onSelect={this.props.selectColaborador}
                    />
                  </div>
                  <div className='pillSelct-pills'>
                    {
                      this.props.colaboradoresSeleccionados.map((colaborador, idColaborador) => (
                        <label key={idColaborador} className='pill pill-cyan pillSelct-pills-item' htmlFor='colaborador'>
                          {colaborador.nombres}
                          <button
                            className='pillSelct-delete'
                            onClick={() => this.props.removeColaborador(colaborador.id)}
                          ><i className='icon ion-close pill-close' />
                          </button>
                        </label>
                      ))
                    }
                  </div>


                </div>
            </div>
            <div className='col-md-6 col-xs-12' style={{ display: 'none' }}>
              {
                this.props.checkAttach.map(checkAttach => (
                  <CondicionCheckbox
                    onCheckAttach={this.onCheckAttach}
                    checkAttach={checkAttach}
                    selectAttachCheck={this.state.selectAttachCheck}
                  />
                ))
              }
            </div>
        </div>
        
        ):null}
        <Observaciones observaciones={this.props.obsFichaVtaVeh} />

        <div className='modal-actions'>
          <button type='button' className='btn btn-return' onClick={this.props.previousStep}>Volver</button>
          <button type='submit' className='btn btn-primary pull-right' disabled={isCreating} onClick={this.submit}>
            {this.props.nuevaFDV ? 'Crear Ficha' : 'Asignar proforma(s)'}
          </button>

          {/*Inicio Req 90859 SoporteLegados 17112021 */}
          <div role='alert' class={this.state.classmensaje} style={{ margin: '45px 0px -50px 0px', borderRadius:'0px' , display: this.state.alerta2}}>
            <i class='ion-alert-circled'></i>
            <span style={{marginLeft: '15px', fontWeight: 'bold'}}>{this.state.mensaje2}</span>
          </div>
          {/*Fin Req 90859 SoporteLegados 17112021 */}

        </div>
        <div className='modal extraFilter' role='dialog' data-backdrop='static' style={{ zIndex: '2000', display: this.state.muestraLoad }} >
          <div className='modal-dialog modal-sm' role='document'>
            <FadeLoader color={'#F8A14A'} loading />
          </div>
        </div>
      </div>

      
    );
  }
}



export default withRouter(ThirdStep);



// WEBPACK FOOTER //
// ./src/pages/modals/NuevaFichaVenta/ThirdStep.js